import { Promotional } from './Promotional';
import { StandardInstallment } from './StandardInstallment';
import {
    Calculation,
    PaymentStructure,
    PaymentFrequency,
} from '@servicetitan/financing-api-client';
import { DeferredInterest } from './DeferredInterest';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';

interface ContainerProps {
    plan: Calculation;
    currentFrequency?: PaymentFrequency;
    placeholder?: boolean;
}

export const Container = ({ plan, currentFrequency, placeholder }: ContainerProps) => {
    const { providerCategory } = useProviderConfig();

    // Default payment frequency to Monthly if not provided
    const defaultPaymentFrequency = currentFrequency ?? PaymentFrequency.Monthly;

    // For second-look providers, always display StandardInstallment
    if (providerCategory === 'second-look') {
        return (
            <StandardInstallment
                plan={plan}
                currentFrequency={defaultPaymentFrequency}
                placeholder={placeholder}
            />
        );
    }

    // `Calculation` (fin-plans-api) and the imported `PaymentStructure` (financing-api) are two
    // identically-valued generated enums; reconcile them so the comparisons are enum-type-safe.
    const paymentStructure = plan.paymentStructure as PaymentStructure;

    // Handle different payment structures for first-look providers
    if (
        paymentStructure === PaymentStructure.Promotional ||
        paymentStructure === PaymentStructure.DeferredInterestAndPrincipal ||
        paymentStructure === PaymentStructure.MixedInterest ||
        (paymentStructure === PaymentStructure.NotSet && plan.hasPromo)
    ) {
        return (
            <Promotional
                plan={plan}
                currentFrequency={defaultPaymentFrequency}
                placeholder={placeholder}
            />
        );
    }

    if (paymentStructure === PaymentStructure.DeferredInterest) {
        return <DeferredInterest plan={plan} placeholder={placeholder} />;
    }

    return (
        <StandardInstallment
            plan={plan}
            currentFrequency={defaultPaymentFrequency}
            placeholder={placeholder}
        />
    );
};
